// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gv-a";
export var fulfillmentFormRail = "_gv-9";
export var headerTitleRow = "_gv-c";
export var orderDetailsWrapper = "_gv-7";
export var orderLinkTrigger = "_gv-2";
export var paymentInformationGrid = "_gv-h";
export var paymentSummaryColumn = "_gv-i";
export var shipmentContainer = "_gv-b";
export var shipmentDetailsMainPane = "_gv-8";
export var shipmentNavigationCard = "_gv-5";
export var shipmentNavigationRail = "_gv-3";
export var shipmentNavigationRailHeader = "_gv-4";
export var shipmentSummaryFact = "_gv-e";
export var shipmentSummaryGrid = "_gv-d";
export var shipmentSummaryMetadataRow = "_gv-f";
export var shipmentSummaryTags = "_gv-g";
export var shipmentWorkspace = "_gv-0";
export var shipmentWorkspaceContent = "_gv-6";
export var shipmentWorkspaceHeader = "_gv-1";